import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
};

export type Dialog = {
  __typename?: 'Dialog';
  dialogId: Scalars['Long'];
  state: Scalars['String'];
};

export type DialogPresence = IPresence & {
  __typename?: 'DialogPresence';
  dialogs?: Maybe<Array<Dialog>>;
  eveUserName?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  topicVersion: Scalars['Long'];
  version: Scalars['Long'];
};

export type IPresence = {
  eveUserName?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  test: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  dialogPresence?: Maybe<DialogPresence>;
  statusPresence?: Maybe<StatusPresence>;
  test: Scalars['String'];
};


export type QueryDialogPresenceArgs = {
  eveUserName: Scalars['String'];
};


export type QueryStatusPresenceArgs = {
  eveUserName: Scalars['String'];
};

export type StatusPresence = IPresence & {
  __typename?: 'StatusPresence';
  eveUserName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  topicVersion: Scalars['Long'];
  version: Scalars['Long'];
};

export type Subscription = {
  __typename?: 'Subscription';
  presence: IPresence;
};


export type SubscriptionPresenceArgs = {
  eveUserName: Scalars['String'];
};

export type PresenceSubscriptionVariables = Exact<{
  eveUserName: Scalars['String'];
}>;


export type PresenceSubscription = { __typename?: 'Subscription', presence: { __typename: 'DialogPresence', state: string, dialogs?: Array<{ __typename?: 'Dialog', dialogId: any, state: string }> | null } | { __typename: 'StatusPresence', status: string } };

export const PresenceDocument = gql`
    subscription Presence($eveUserName: String!) {
  presence(eveUserName: $eveUserName) {
    __typename
    ... on DialogPresence {
      state
      dialogs {
        dialogId
        state
      }
    }
    ... on StatusPresence {
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PresenceGQL extends Apollo.Subscription<PresenceSubscription, PresenceSubscriptionVariables> {
    override document = PresenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }